module.exports = __webpack_public_path__ + "img/036.c15ff580.jpg";